import React from 'react';
import { Box, Typography, Button, Alert, Select, MenuItem, FormControl, TextField } from '@mui/material';
import { C } from '../../../theme';

// ============================================================
// HandleInput
// Reusable platform + handle input row.
// ============================================================
export function HandleInput({ handle, setHandle, platform, setPlatform, onSubmit, submitLabel, disabled }) {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
      <FormControl size="small" sx={{ minWidth: 110 }}>
        <Select value={platform} onChange={e => setPlatform(e.target.value)}>
          <MenuItem value="instagram">Instagram</MenuItem>
          <MenuItem value="linkedin">LinkedIn</MenuItem>
        </Select>
      </FormControl>
      <TextField size="small" label="Your handle" value={handle}
        onChange={e => setHandle(e.target.value)} inputProps={{ maxLength: 35 }} sx={{ flex: 1, minWidth: 120 }} />
      <Button variant="contained" size="small" onClick={onSubmit}
        disabled={disabled || !handle.trim()}>
        {submitLabel}
      </Button>
    </Box>
  );
}

// ============================================================
// SocialAskBar
// Renders social exchange controls — deduplicates Section B and D.
// variant='early' — used in Section B (structured Q phase)
//   - label above input, submitLabel "Share & Ask", shows recipAskAfterShare
//   - ask button: "Ask for their social handle"
// variant='late'  — used in Section D (spotting/meet phase)
//   - label below input, submitLabel "Go", no recipAskAfterShare
//   - ask button: "Can I have your social or Insta ID?"
// ============================================================
export default function SocialAskBar({
  variant,
  ui, serverState, pendingSocialQ,
  handle, setHandle, platform, setPlatform,
  handleShareAndAsk, handleAskOnly,
}) {
  const isEarly = variant === 'early';

  if (serverState?.socialExchangePending && !pendingSocialQ) {
    return (
      <Alert severity="info" sx={{ mb: 1 }} icon={false}>
        Social exchange in progress — waiting for their response.
      </Alert>
    );
  }

  if (serverState?.socialExchangePending || pendingSocialQ) return null;

  return (
    <>
      {ui.showShareAndAskBtn && (
        <Box sx={{ mb: isEarly ? 1.5 : 0 }}>
          {isEarly && (
            <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: C.textMuted }}>
              Share yours and ask for theirs:
            </Typography>
          )}
          <HandleInput
            handle={handle} setHandle={setHandle}
            platform={platform} setPlatform={setPlatform}
            onSubmit={handleShareAndAsk}
            submitLabel={isEarly ? 'Share & Ask' : 'Go'}
          />
          {!isEarly && (
            <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: C.textMuted }}>
              Share yours and ask for theirs
            </Typography>
          )}
        </Box>
      )}

      {serverState?.alreadySharedHandle && (
        <Alert severity="success" sx={{ mb: 1 }} icon={false}>✅ Your handle shared</Alert>
      )}

      {ui.showAskOnlyBtn && (
        <Button variant="outlined" fullWidth size="small"
          sx={{ borderColor: C.yellow, color: C.yellow, justifyContent: 'flex-start', pl: 2 }}
          onClick={handleAskOnly}>
          {isEarly ? 'Ask for their social handle' : 'Can I have your social or Insta ID?'}
        </Button>
      )}

      {isEarly && ui.showRecipAskAfterShare && (
        <Button variant="outlined" fullWidth size="small" sx={{ mb: 1 }} onClick={handleAskOnly}>
          Now ask for their handle
        </Button>
      )}
    </>
  );
}
